import React from 'react';
import { TrendingUp } from 'lucide-react';
import type { NutritionTargets } from '../types/mealMonitor';

interface DailySummaryCardProps {
  totalCalories: number;
  totalProtein: number;
  totalFat: number;
  totalCarbs: number;
  totalFiber: number;
  entriesCount: number;
  nutritionTargets?: NutritionTargets;
}

const DailySummaryCard: React.FC<DailySummaryCardProps> = ({
  totalCalories,
  totalProtein,
  totalFat,
  totalCarbs,
  totalFiber,
  entriesCount,
  nutritionTargets
}) => {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-200 p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
          <TrendingUp className="h-4 w-4 text-white" />
        </div>
        <div>
          <h3 className="text-base font-semibold text-gray-900">Итого за день</h3>
          <p className="text-xs text-gray-600">Записей: {entriesCount}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        <div className={`rounded-lg p-2 shadow-sm ${
          nutritionTargets?.daily_calories && totalCalories > nutritionTargets.daily_calories
            ? 'bg-red-50 border border-red-200'
            : 'bg-white'
        }`}>
          <div className="text-xs text-gray-500 mb-0.5">Калории</div>
          <div className={`text-lg font-bold ${
            nutritionTargets?.daily_calories && totalCalories > nutritionTargets.daily_calories
              ? 'text-red-600'
              : 'text-blue-600'
          }`}>
            {totalCalories.toFixed(0)}
            {nutritionTargets?.daily_calories && (
              <span className="text-xs text-gray-400 font-normal"> / {nutritionTargets.daily_calories.toFixed(0)}</span>
            )}
            <span className="text-xs text-gray-400 font-normal"> ккал</span>
          </div>
        </div>

        <div className="bg-white rounded-lg p-2 shadow-sm">
          <div className="text-xs text-gray-500 mb-0.5">Белки</div>
          <div className="text-lg font-bold text-green-600">
            {totalProtein.toFixed(1)}
            {nutritionTargets?.daily_protein && (
              <span className="text-xs text-gray-400 font-normal"> / {nutritionTargets.daily_protein.toFixed(1)}</span>
            )}
            <span className="text-xs text-gray-400 font-normal"> г</span>
          </div>
        </div>

        <div className="bg-white rounded-lg p-2 shadow-sm">
          <div className="text-xs text-gray-500 mb-0.5">Жиры</div>
          <div className="text-lg font-bold text-yellow-600">
            {totalFat.toFixed(1)} <span className="text-xs text-gray-400 font-normal">г</span>
          </div>
        </div>

        <div className="bg-white rounded-lg p-2 shadow-sm">
          <div className="text-xs text-gray-500 mb-0.5">Углеводы</div>
          <div className="text-lg font-bold text-orange-600">
            {totalCarbs.toFixed(1)} <span className="text-xs text-gray-400 font-normal">г</span>
          </div>
        </div>

        <div className="bg-white rounded-lg p-2 shadow-sm">
          <div className="text-xs text-gray-500 mb-0.5">Клетчатка</div>
          <div className="text-lg font-bold text-purple-600">
            {totalFiber.toFixed(1)}
            {nutritionTargets?.daily_fiber && (
              <span className="text-xs text-gray-400 font-normal"> / {nutritionTargets.daily_fiber.toFixed(1)}</span>
            )}
            <span className="text-xs text-gray-400 font-normal"> г</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailySummaryCard;
